import React, { useEffect, useRef, useState } from 'react'
import './App.scss'

const PROJECTS = [
  {
    size: 'wide',
    name: 'SmartHytte',
    domain: 'hytte.tech',
    href: 'https://hytte.tech',
    kind: 'Domy Loxone',
    who: 'Jakub',
    blurb: 'Automatyka Loxone we Wrocławiu i na Dolnym Śląsku — projekt, programowanie, montaż, serwis. Dokumentacja i dane zostają Twoje.',
    tags: ['Loxone', 'Smart home', 'Wrocław'],
    accent: '122, 206, 46'
  },
  {
    size: 'lg',
    name: 'MoonForge',
    domain: 'moonforge.tech',
    href: 'https://moonforge.tech',
    kind: 'Studio R&D',
    who: 'Jakub',
    blurb: 'Trochę software, trochę hardware. OCR, ElectriCAD, parę innych zabawek.',
    tags: ['OCR', 'CAD', 'Hardware'],
    accent: '255, 157, 77'
  },
  {
    size: 'wide',
    name: 'DWG Viewer',
    domain: 'dwg.moonforge.tech',
    href: 'https://dwg.moonforge.tech/pl',
    kind: 'Open source',
    who: 'Jakub',
    blurb: 'Pliki DWG i DXF w przeglądarce, bez AutoCADa i bez wysyłania rysunku. Pomiar i wydruk do PDF w skali.',
    tags: ['DWG', 'WebAssembly', 'GPL'],
    accent: '167, 139, 250'
  },
  {
    size: 'wide',
    name: 'Czary Marry',
    domain: 'czarymarry.com',
    href: 'https://czarymarry.com',
    kind: 'Agencja ślubna',
    who: 'Kasia & Ola',
    blurb: 'Ogarniają śluby i wesela. Nie moje, ale polecam :)',
    accent: '255, 77, 157'
  },
  {
    size: 'wide',
    name: 'Lava Lamp',
    domain: 'lava-lamp-visualizer.netlify.app',
    href: 'https://lava-lamp-visualizer.netlify.app',
    kind: 'Weekendowy projekt',
    who: 'Jakub',
    blurb: 'Metaballe, które ruszają się do muzyki. Sobotnie dłubanie.',
    accent: '255, 120, 90'
  }
]

const SMALL = [
  { label: 'Medium', note: 'Notatki', href: 'https://medium.com/@jaaaco' },
  { label: 'GitHub', note: 'Kod', href: 'https://github.com/jaaaco' }
]

const SOCIALS = [
  { label: 'GitHub', href: 'https://github.com/jaaaco' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/jaaaco' },
  { label: 'Email', href: 'mailto:jakub@wietrzyk.com' },
  { label: 'X', href: 'https://x.com/jaaaco' }
]

const PALETTE = [
  [255, 138, 61],
  [255, 90, 120],
  [255, 179, 71],
  [224, 69, 123],
  [255, 120, 200]
]

function FluidCanvas ({ hot }) {
  const ref = useRef(null)
  const hotRef = useRef(null)
  const pointer = useRef({ x: 0.5, y: 0.4, active: false })

  useEffect(() => { hotRef.current = hot }, [hot])

  useEffect(() => {
    const canvas = ref.current
    const ctx = canvas.getContext('2d')
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    let w = 0, h = 0, dpr = 1, raf = null, t = 0

    const blobs = []
    for (let i = 0; i < 7; i++) {
      blobs.push({
        x: Math.random(),
        y: Math.random(),
        r: 0.2 + Math.random() * 0.24,
        sx: (Math.random() - 0.5) * 0.00018,
        sy: -0.00007 - Math.random() * 0.00014,
        ph: Math.random() * Math.PI * 2,
        sp: 0.4 + Math.random() * 0.7,
        color: PALETTE[i % PALETTE.length]
      })
    }

    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, 2)
      w = canvas.clientWidth
      h = canvas.clientHeight
      canvas.width = Math.round(w * dpr)
      canvas.height = Math.round(h * dpr)
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    }
    resize()
    window.addEventListener('resize', resize)

    const onMove = (e) => {
      pointer.current.x = e.clientX / window.innerWidth
      pointer.current.y = e.clientY / window.innerHeight
      pointer.current.active = true
    }
    if (!reduce && !window.matchMedia('(hover: none)').matches) {
      window.addEventListener('pointermove', onMove)
    }

    const draw = () => {
      const minSide = Math.min(w, h)
      ctx.globalCompositeOperation = 'source-over'
      ctx.fillStyle = '#06050a'
      ctx.fillRect(0, 0, w, h)
      ctx.globalCompositeOperation = 'lighter'

      const hotCol = hotRef.current
      const p = pointer.current

      for (let i = 0; i < blobs.length; i++) {
        const b = blobs[i]
        b.x += b.sx
        b.y += b.sy
        const bob = Math.sin(t * b.sp + b.ph) * 0.04
        let cx = (b.x + Math.cos(t * b.sp * 0.7 + b.ph) * 0.05) * w
        let cy = (b.y + bob) * h

        if (b.y < -0.4) b.y = 1.4
        if (b.x < -0.4) b.x = 1.4
        if (b.x > 1.4) b.x = -0.4

        if (p.active) {
          cx += (p.x * w - cx) * 0.035
          cy += (p.y * h - cy) * 0.035
        }

        const pulse = 1 + Math.sin(t * b.sp * 1.3 + b.ph) * 0.12
        const rad = b.r * minSide * pulse

        let col = b.color
        if (hotCol) {
          col = [
            Math.round(b.color[0] * 0.4 + hotCol[0] * 0.6),
            Math.round(b.color[1] * 0.4 + hotCol[1] * 0.6),
            Math.round(b.color[2] * 0.4 + hotCol[2] * 0.6)
          ]
        }

        const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, rad)
        g.addColorStop(0, 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',0.85)')
        g.addColorStop(0.45, 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',0.3)')
        g.addColorStop(1, 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',0)')
        ctx.fillStyle = g
        ctx.beginPath()
        ctx.arc(cx, cy, rad, 0, Math.PI * 2)
        ctx.fill()
      }
    }

    if (reduce) {
      t = 2
      draw()
    } else {
      const loop = () => { t += 0.006; draw(); raf = requestAnimationFrame(loop) }
      loop()
    }

    return () => {
      if (raf) cancelAnimationFrame(raf)
      window.removeEventListener('resize', resize)
      window.removeEventListener('pointermove', onMove)
    }
  }, [])

  return <canvas className="fluid" ref={ref} aria-hidden="true" />
}

function Arrow ({ size = 16 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path d="M7 17L17 7M17 7H9M17 7V15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function App () {
  const [time, setTime] = useState('')
  const [hot, setHot] = useState(null)

  useEffect(() => {
    const els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'))
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in'))
      return
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target) }
      })
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' })
    els.forEach(el => io.observe(el))
    return () => io.disconnect()
  }, [])

  useEffect(() => {
    const fmt = () => {
      try {
        setTime(new Intl.DateTimeFormat('pl-PL', {
          hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Warsaw'
        }).format(new Date()))
      } catch (e) { /* noop */ }
    }
    fmt()
    const id = setInterval(fmt, 30000)
    return () => clearInterval(id)
  }, [])

  const parse = (rgb) => rgb.split(',').map(n => parseInt(n, 10))
  const enter = (p) => () => setHot(parse(p.accent))
  const leave = () => setHot(null)

  return (
    <div className="page">
      <FluidCanvas hot={hot} />
      <div className="fluid-scrim" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />

      <header className="nav">
        <a className="nav__mark" href="/">Wietrzyk<span>.</span></a>
        <div className="nav__meta">
          <span className="nav__dot" /> Wrocław {time && <em>· {time}</em>}
        </div>
      </header>

      <main>
        <section className="hero">
          <p className="hero__eyebrow" data-reveal>
            <span className="hero__pulse" /> domena rodzinna
          </p>
          <h1 className="hero__title" data-reveal>
            <span className="line">Rodzina</span>
            <span className="line line--accent">Wietrzyk</span>
          </h1>
          <p className="hero__lead" data-reveal>
            Jedna domena, kilka osób. Każde z nas dłubie przy swoim,
            a tu wszystko w jednym miejscu.
          </p>
        </section>

        <section className="work" id="swiaty">
          <div className="work__head" data-reveal>
            <h2><span>Co robimy</span></h2>
          </div>

          <div className="bento">
            {PROJECTS.map(p => (
              <a
                key={p.name}
                className={'tile tile--' + p.size}
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ '--accent': p.accent }}
                onMouseEnter={enter(p)}
                onMouseLeave={leave}
                data-reveal
              >
                <div className="tile__top">
                  <span className="tile__kind">{p.kind}</span>
                  <span className="tile__who">{p.who}</span>
                </div>
                <div className="tile__body">
                  <h3 className="tile__name">{p.name}</h3>
                  <p className="tile__blurb">{p.blurb}</p>
                </div>
                <div className="tile__foot">
                  {p.tags
                    ? <div className="tile__tags">{p.tags.map(t => <span key={t}>{t}</span>)}</div>
                    : <span />}
                  <span className="tile__link">{p.domain}<Arrow /></span>
                </div>
              </a>
            ))}

            {SMALL.map(s => (
              <a
                key={s.label}
                className="tile tile--sm"
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-reveal
              >
                <div className="tile__sm-top">
                  <span className="tile__sm-label">{s.label}</span>
                  <Arrow />
                </div>
                <span className="tile__sm-note">{s.note}</span>
              </a>
            ))}

            <a className="tile tile--mail" href="mailto:jakub@wietrzyk.com" data-reveal>
              <span className="tile__sm-note">napisz</span>
              <span className="tile__mail">jakub@wietrzyk.com</span>
            </a>
          </div>
        </section>

        <section className="contact" id="kontakt">
          <h2 className="contact__title" data-reveal>Odezwij się.</h2>
          <p className="contact__hint" data-reveal>Każde z nas ma adres @wietrzyk.com</p>
        </section>
      </main>

      <footer className="foot">
        <span className="foot__copy">© {new Date().getFullYear()} Wietrzyk</span>
        <nav className="foot__social">
          {SOCIALS.map(s => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer">{s.label}</a>
          ))}
        </nav>
      </footer>
    </div>
  )
}

export default App
